import { DocumentIsogd } from "isogd-document-rest";

class DocumentRequisitesViewController {
    private document: DocumentIsogd;
}

export const DocumentRequisitesViewComponent: angular.IComponentOptions = {
    controller: DocumentRequisitesViewController,
    template: require('./documentRequisitesView.html'),
    bindings: {
        document: "<"
    }
};


// WEBPACK FOOTER //
// ./src/components/document/document-requisites/documentRequisitesView.ts